import type { Domain } from "~/services/DomainService";
import type { Brand } from "~/services/BrandService";
import type { Location } from "~/services/LocationService";
import type { MailTemplate } from "~/services/MailTemplateService";
import { state } from "@formkit/drag-and-drop";

export const useDomain = () =>
    useState<Domain>("domain", () => undefined as unknown as Domain);
export const useBrand = () =>
    useState<Brand>("domain", () => undefined as unknown as Brand);
export const useLocation = () =>
    useState<Location>("location", () => undefined as unknown as Location);

export const useErrorNotification = () =>
    useState<boolean>("error_notification", () => false);

export const useMailTemplate = () =>
    useState<MailTemplate>(
        "mail_template",
        () => undefined as unknown as MailTemplate,
    );

export interface PartnerContext {
    app: string;
    tenant: string;
    user_id?: string;
    metadata?: Record<string, string>;
}

export const usePartnerContext = (context?: PartnerContext) => {
    const partnerContext = useState<PartnerContext | undefined>("partner_context", () => undefined);

    if (context) {
        partnerContext.value = {
            ...(partnerContext.value ?? {}),
            ...context,
        };
    }

    return partnerContext;
};